<template>
  <div class="solution-download-bkg">
    <headers :params="hraderP"></headers>
    <van-row class="download-tip-row">
      <van-col :span="24" class="item-title"><img src="../../../assets/images/soudownload.png" />本方案为付费方案，仅需{{info.total}}元，即可下载完整方案资料</van-col>
    </van-row>
    <van-row class="solution-download-row">
      <van-col :span="24" class="item-title cal-info">结算信息</van-col>
    </van-row>
    <van-row class="solution-download-row">
      <van-col :span="24" class="item-title">使用河币 <span>(1河币=1元)</span></van-col>
    </van-row>
    <van-row class="solution-download-row">
      <van-col :span="24" class="item-title">使用数量 <input type="number" placeholder="请输入河币数量" class="wirte-hb" v-model="info.hbNum" @input="changeHb"></van-col>
    </van-row>
    <van-row class="solution-download-row">
      <van-col :span="24" class="item-title text-right hb-money"><div>-河币:<span>￥{{info.hbNum}}</span></div></van-col>
    </van-row>
    <van-row class="solution-download-row">
      <van-col :span="24" class="item-title no-border text-right total-money">应付总额:<span>￥{{(info.total - info.hbNum) }}</span></van-col>
    </van-row>
    <van-row>
      <van-col :span="24">
        <button class="sub-demand-btn" @click="pay">立即支付</button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import headers from '@/components/headers'
import {Row, Col, Toast} from 'vant'
import { createOrder, getTotalCoin, checkDownloadAuth, dealAwaitOrder, queryCreateOrderNo, getOrderInfoByOrderNo, creatOrderInfo } from '@/api/solutions/solution'
import { mapState } from 'vuex'
import { toLogin } from '@/utils/common'
import { getCookie, removeCookie } from '@/utils/cookies'
import miniProgramPayment from '@/mixins/miniProgramPayment'
export default {
  name: 'solution-download',
  mixins: [miniProgramPayment],
  components: { Row, Col, headers },
  computed: {
    ...mapState({
      token: state => state.user.ticket,
      // userId: state => state.user.AccountId,
      userName: state => state.user.AccountName
    })
  },
  data () {
    return {
      hraderP: {
        title: '方案下载',
        lefticon: true
      },
      info: {
        total: 0, // 方案总价
        hbNum: 0 // 河币个数
      },
      postData: {
        businessId: 0,
        businessName: '',
        businessType: 1, // 业务类型 1：方案 2：行业规范 3：需求定制 4:品牌管理员申请缴费
        couponAmount: 0,
        hebiAmount: 0,
        amount: 0,
        os: '',
        // returnUrl: '',
        userId: 0,
        orderNo: ''
      },
      orderNo: '',
      orderId: '',
      HbCoin: 0,
      queryData: {
        userId: 0,
        businessType: 1,
        businessId: null
      },
      userId: 0,
      ajaxNum: 0,

      toast: null,
      detailPageUrl: '' // 详情页url

    }
  },
  created () {
    this.userId = getCookie('accountId') ? getCookie('accountId') : 0
    this.postData.businessId = this.$route.query.businessId
    this.postData.businessName = this.$route.query.businessName
    this.postData.userId = getCookie('accountId') ? getCookie('accountId') : 0
    this.detailPageUrl = this.$route.query.backUrl
    // this.postData.returnUrl = 'https://pay.' + $HMD$.rApi.S + 'homedo.com/Cashier/FrontReturnCallback'

    this.info.total = this.$route.query.total
    this.queryData.userId = getCookie('accountId') ? getCookie('accountId') : 0
    this.queryData.businessId = this.$route.query.businessId
    this.getCreateOrderNo()
  },
  mounted () {
    this.postData.os = $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator
    this.getHbCoin()
  },
  methods: {
    getAppAccountId() {
      return new Promise((resolve, reject) =>{
        $HMD$.GetLogin(function (data) {
          resolve(data && data.AccountId || '')
        })
      });
    },
    async getHbCoin () {
      if ($HMD$.rNavigator !== 'msite' && !this.userId) {
        this.userId = await this.getAppAccountId()
      }
      getTotalCoin(this.userId).then(res => {
        if (res.status === 200 && res.data && res.data.respCode === '0000') {
          this.HbCoin = res.data.data ? Number(res.data.data.newAmount) : 0
        }
      })
    },
    changeHb () {
      this.info.hbNum = this.info.hbNum.replace(/[^\d]/g, '')
      if (this.info.hbNum > this.info.total * 100 || this.info.hbNum > this.HbCoin) {
        this.info.hbNum = this.info.hbNum.substring(0, this.info.hbNum.length - 1)
      }
      if (this.info.hbNum > this.HbCoin) {
        this.info.hbNum = this.info.hbNum.substring(0, this.info.hbNum.length - 1)
        Toast('您输入的河币数量大于持有量,请重新输入')
      }
    },
    pay () {
      // if (!this.postData.userId) {
      //   // 登录失效
      //   toLogin()
      // }
      if (!getCookie('ticket')) {
        // 跳转登录页面
        toLogin()
      } else if ($HMD$.rNavigator === 'msite' && (!getCookie('accountId') && !getCookie('AccountId'))) {
        toLogin()
      }
      this.checkOrder()
    },
    // 校验订单
    async checkOrder () {
      this.toast = Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      })
      //  查询当前业务的支付状态
      //  待支付---》 收银台
      //  未支付---》
      //  20：待付款 30：付款完成 40：支付失败 50：已取消 60：待审核 70 审核失败
      // 2 -处理中 3-线下支付待审核 ,
      if ($HMD$.rNavigator !== 'msite' && !this.queryData.userId) {
        this.queryData.userId = await this.getAppAccountId()
      }
      let orderStatus = await checkDownloadAuth(this.queryData)
      if (orderStatus.data.respCode === '0000' && orderStatus.status === 200) {
        if (orderStatus.data.data && orderStatus.data.data.plusUser == 1) {
          // 跳转下载页面
          this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
        } else if (orderStatus.data.data && !orderStatus.data.data.hasPayOrder) {
          // 无订单
          this.createNewOrder()
        } else {
          this.toast.clear()
          if (orderStatus.data.data) {
            var orStatus = orderStatus.data.data.status
            var payStatus = orderStatus.data.data.payStatus
            switch (orStatus) {
              case 20:
                // 支付待审核
                if (payStatus) {
                  if (payStatus == 2) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo)
                  }
                  if (payStatus == 3) {
                    Toast('当前订单审核中，请稍等！')
                  }
                  if (payStatus == 1) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo)
                  }
                } else {
                  this.doAwaitOrder(orderStatus.data.data.orderNo)
                }
                break
              case 30:
                // 跳转下载页面
                this.$router.push(`/downloadFree/${this.detail.solutionId}.html`)
                break
              case 40:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
              case 50:
                // 已取消订单不具备下载权限，重新创建订单。
                this.createNewOrder()
                break
              case 60:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
              case 70:
                this.doAwaitOrder(orderStatus.data.data.orderNo)
                break
            }
          }
        }
      } else {
          this.toast.clear()
      }
    },
    async doAwaitOrder (orderNo) {
      if ($HMD$.rNavigator !== 'msite' && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId()
      }
      dealAwaitOrder(orderNo, this.postData).then(res => {
        if (res.status === 200 && res.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.getOrderIdToMiniProgram(orderNo)
          } else if (window.$HMD$.rNavigator.toLowerCase() === 'ios') {
            this.getOrderIdToIos(orderNo, res.data.data.url)
          } else {
            window.location.href = res.data.data.url
          }
        } else {
          Toast('抱歉，下载权限校验失败!')
        }
      })
    },
    getOrderIdToIos (orderNo, jumpUrl) {
      getOrderInfoByOrderNo(orderNo).then((res) => {
        if (res.data.code !== 1000 && res.data.msg === '处理成功') {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            'name': 'FangAnGuanOrderId',
            'orderId': res.data.code && res.data.code.toString()
          })
        }
        window.location.href = jumpUrl
      })
    },
    createNewOrder () {
      this.ajaxNum = 0
      this.postCreatOrderInfo()
    },
    // 获取平台唯一销售订单编号orderNo
    getCreateOrderNo () {
      queryCreateOrderNo().then(res => {
        if (res.status !== 200) {
          return
        }
        if (res.data.respCode !== '0000') {
          return
        }
        this.orderNo = res.data.respDesc
      })
    },
    // 创建平台订单信息
    async postCreatOrderInfo () {
      this.postData.amount = this.info.total - this.info.hbNum
      this.postData.hebiAmount = this.info.hbNum
      this.postData.orderNo = this.orderNo
      if ($HMD$.rNavigator !== 'msite' && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId()
      }
      creatOrderInfo(this.postData).then(res => {
        if (res.data && res.data.respCode === '0000') {

        } else {
          // Toast(res.data.respDesc, '服务异常')
        }
      })
      this.queryOrderInfoByOrderNo()
    },
    // 轮询接口,前端调用的查缓存接口
    async queryOrderInfoByOrderNo () {
      if ($HMD$.rNavigator !== 'msite' && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId()
      }
      let t = setInterval(() => {
        this.ajaxNum += 1
        getOrderInfoByOrderNo(this.postData.orderNo).then((res) => {
          if (this.ajaxNum > 9) {
            this.toast.clear()
            clearInterval(t)
          }
          if (res.data.code !== 1000 && res.data.msg === '处理成功') {
            clearInterval(t)
            this.orderId = res.data.code
            this.createNewOrderLast()
          }
        })
      }, 1000)
    },
    // 创建订单,页面跳转
    async createNewOrderLast () {
      this.postData.amount = (this.info.total * 100 - this.info.hbNum) / 100
      this.postData.hebiAmount = this.info.hbNum
      this.postData.orderNo = this.orderId
      if ($HMD$.rNavigator !== 'msite' && !this.postData.userId) {
        this.postData.userId = await this.getAppAccountId()
      }
      createOrder(this.postData).then(count => {
        this.toast.clear()
        if (this.postData.amount === 0 && count.status === 200 && count.data && count.data.respCode === '0000') {
          if(getCookie('fromnewfangan') == 'yes'){
            window.location.href = this.detailPageUrl
          }else{
            if (this.detailPageUrl.split('.html')[1].indexOf('?') > 0) {
              window.location.href = `${this.detailPageUrl}&code=0`
            } else {
              window.location.href = `${this.detailPageUrl}?code=0`
            }
          }
          return
        }
        if (count.status !== 200) {
          Toast('请检查网络')
          return
        }
        if (count.status === 200 && count.data && count.data.respCode !== '0000') {
          Toast(count.data.respDesc)
          return
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.redirectToMiniProgramPayment(this.orderId)
            return
          }
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000' && count.data.data && count.data.data.url) {
          // eslint-disable-next-line no-undef
          if ($HMD$.rNavigator.toLowerCase() === 'ios') {
            // eslint-disable-next-line no-undef
            $HMD$.M.sendApp({
              'name': 'FangAnGuanOrderId',
              'orderId': this.orderId && this.orderId.toString()
            })
          }
          window.location.href = count.data.data.url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.solution-download-bkg{
  background-color: #F5F5F5;
  .download-tip-row{
    background-color: #FCF9DA;
    padding-left: 4%;
    padding-right: 4%;
    height: 40px;
    .item-title{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: 10px;
      font-size: 12px;
      color: #EB5D2A;
      img{
        width: 18px;
        height: 18px;
        vertical-align: middle;
        margin-right: 4px;
      }
    }
  }
  .solution-download-row{
    background-color: #ffffff;
    padding-left: 4%;
    padding-right: 4%;
    height: 44px;
    font-size: 14px;
    .item-title{
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      color: #222222;
      line-height: 44px;
      border-bottom: 0.5px solid #D8D8D8;
      &.no-border{
        border: 0;
      }
      &.text-right{
        text-align: right;
      }
      &.hb-money{
        font-size: 12px;
        span{
          color: #E52B2B;
        }
      }
      &.total-money{
        font-size: 16px;
        span{
          color: #E52B2B;
        }
      }
      &.cal-info::before{
         display: inline-block;
         vertical-align: middle;
         content: '';
         width: 2px;
         height: 16px;
         background-color: #1dbfda;
         margin-right: 5px;
        margin-top: -2px;
       }
      span{
        color: #CFCFD8;
        font-size: 12px;
        margin-left: 13px;
      }
      input.wirte-hb{
        border: 0;
        background: transparent;
        font-size: 12px;
        margin-left: 13px;
        width: 70%;
        // color: #CFCFD8;
      }
      ::-webkit-input-placeholder {
        color: #cfcfd8;
      }
    }
  }
  .sub-demand-btn{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    font-size: 18px;
    color: #FFFFFF;
    border: none;
    background-color: #007CFF;
  }
  .bottom-style{
    height: 50px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/download.vue